export default __webpack_public_path__ + "static/Group 118@2x-dfd0c40ff3488117248f4cb8895a4af4.png";